import { FC } from "react";
import { CardCore, CardProps } from "./Card";
import cx from "classnames";
import style from "./Card.module.scss";
import { Article } from "../../routes";

export const NavifationCard: FC<CardProps & {id: number, label: string}> = ({
  className,
  big,
  id,
  label,
  ...rest
}) => {
  return (
    <div
      className={cx(style.card, style['navigation-card'], className, {
        "big-card": big,
      })}
    >
      <Article.Link id={id} label={label}>
        <CardCore {...rest} />
      </Article.Link>
    </div>
  );
};
